export default {
  namespaced: true,

  state: {
    meta: {},
  },

  mutations: {
    meta: (state, meta) => {
      state.meta = meta
    },
  },

  actions: {
    setMeta (meta) {
      this.commit('meta', meta)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/route.js